// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22FWP","fullView":"styles_fullView__3sDBk"};